import { render, staticRenderFns } from "./AppIframe.vue?vue&type=template&id=8d81ee3e&scoped=true&"
import script from "./AppIframe.vue?vue&type=script&lang=js&"
export * from "./AppIframe.vue?vue&type=script&lang=js&"
import style0 from "./AppIframe.vue?vue&type=style&index=0&id=8d81ee3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d81ee3e",
  null
  
)

export default component.exports